exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assess-item[data-v-694fc074]{margin-bottom:0}[data-v-694fc074] .el-input-number{width:120px}\n", ""]);

// exports
